module.exports = __webpack_public_path__ + "img/ascend_gold47.e5a6c50d.png";